import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField } from '@anytag/shared-molecules';
import { AssociatedAccountFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  keywordPlaceholder?: string;
}

export const Template = ({ onSubmit, keywordPlaceholder }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField<AssociatedAccountFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        css={{ maxWidth: '35%' }}
        title={t('Search.Keyword')}
        placeholder={keywordPlaceholder}
      />
    </Form.Fields>
  );
};
